import Button from 'react-bootstrap/Button';
import React from 'react';
import './ProduktSklepList.css';

export default function ProduktSklepList(prop) {
    console.log("produkt:" + JSON.stringify(prop.produkt));

    return (
        <tr className="tabela">
            <td className="td-img">
                <img alt="a" style={{ maxWidth: 180 + 'px', minWidth: 180 + 'px' }} src={prop.produkt.logo_url} />
            </td>
            <td className="jeden"><a target="_blank" href={"" + process.env.REACT_APP_PS_SKLEP_SITE + "/sklep/" + prop.produkt.ids + ",prod," + prop.produkt.id}><h5 className="m-0 p-0">{prop.produkt.sklepnazwa}</h5></a></td>
            <td className="dwa"><a target="_blank" href={"" + process.env.REACT_APP_PS_SKLEP_SITE + "/sklep/" + prop.produkt.ids + ",prod," + prop.produkt.id}><h5 className="m-0 p-0">{prop.produkt.nazwa}</h5></a>
       Marka: <strong>{prop.produkt.marka}</strong>
                <br />EAN: <strong><a target="_blank" href={"https://www.eprodukty.gs1.pl/catalog/0"+prop.produkt.ean}>{prop.produkt.ean}</a></strong>
                <br />nr kat:<strong>{prop.produkt.nrkatalogowy}</strong>
                <br /><DodajButton dane={prop} />
            </td>
            <td className="trzy">{prop.produkt.opis}</td>
        </tr>
    );

    function DodajButton(prop) {
        //bierzemy producent z prawej strony
        //sprawdzamy warunki dodania
        //wyświetlamy okno z informacją jak dodajemy i jak są spełnione to dodajemy
        //jak dodajmy to przechodzimy również na firmę do której dodajmy
        //
        //a w systemie jak jest kod produktu to już sklep nie będzie mógł zmienić ani nazwy niczego 

        function DodajProdukt() {
            console.log("DodajProdukt");
            prop.dane.produkt.infodod = "info dodj";
            console.log("doda produkts prop.produkt    " + prop.dane.produkt.nazwa);
            prop.dane.bref.dodajfu(prop.dane, prop.dane.produkt);
            console.log("doda produkt");
        }
        return (<Button variant="primary" onClick={DodajProdukt}>Dodaj</Button>)
    }


}
